import { get, post } from './mainApi';

const timesheetBaseURL = process.env.REACT_APP_TIMESHEET_MANAGEMENT_ENDPOINT;

const weeklyProjectRelatedWorkURL =
  process.env.REACT_APP_WORKLOG_MANAGEMENT_ENDPOINT +
  '/weekly-projects-summary';

const actualHoursURL =
  process.env.REACT_APP_PROJECT_MANAGEMENT_ENDPOINT +
  'project-working-hours-distribution/all-distributions-chart';

const monthlyHoursURL =
  process.env.REACT_APP_WORKLOG_MANAGEMENT_ENDPOINT + '/project-monthly-hours';

const projectDeliveryUrl =
  process.env.REACT_APP_WORKLOG_MANAGEMENT_ENDPOINT +
  '/project-delivery-status';

const projectDeliveryInvoiceUrl =
  process.env.REACT_APP_WORKLOG_MANAGEMENT_ENDPOINT +
  '/project-delivery-invoice-status';

const timesheetUrl =
  process.env.REACT_APP_WORKLOG_MANAGEMENT_ENDPOINT + '/time-sheet';

const weeklyProjectAllocationSummaryURL =
  process.env.REACT_APP_WORKLOG_MANAGEMENT_ENDPOINT +
  '/weekly-project-Allocation-summary';

const projectProgressURL =
  process.env.REACT_APP_WORKLOG_MANAGEMENT_ENDPOINT + '/project-progress';

const sowPoURL =
  process.env.REACT_APP_PROJECT_MANAGEMENT_ENDPOINT + 'update-status';

const sowPoFilterURL =
  process.env.REACT_APP_PROJECT_MANAGEMENT_ENDPOINT + 'update-status-filter';

export const getAllEmployeesTimeSheet = async () => {
  var response = get(timesheetBaseURL);
  return response;
};

export const getSowPO = async () => {
  var response = get(sowPoURL);
  return response;
};

export const searchSowPO = async (keyword) => {
  var response = get(`${sowPoURL}/search?name=${keyword}`);
  return response;
};

export const filterSowPO = async (data) => {
  var response = post(`${sowPoFilterURL}`, data);
  return response;
};

export const getProgressStatus = async () => {
  var response = get(projectProgressURL);
  return response;
};

export const searchProgressStatus = async (keyword: string) => {
  var response = post(`${projectProgressURL}/search`, {
    projectName: keyword
  });
  return response;
};

export const filterProgressStatus = async (data: any) => {
  var response = post(`${projectProgressURL}/filter`, data);
  return response;
};

export const getWeeklyProjectAllocation = async () => {
  var response = get(weeklyProjectAllocationSummaryURL);
  return response;
};

export const searchWeeklyProjectAllocation = async (keyword: string) => {
  var response = post(`${weeklyProjectAllocationSummaryURL}/search`, {
    projectName: keyword
  });
  return response;
};

export const filterWeeklyProjectAllocation = async (data: any) => {
  var response = post(`${weeklyProjectAllocationSummaryURL}/filtering`, data);
  return response;
};

export const getWeeklyProjectRelatedWork = async () => {
  var response = get(weeklyProjectRelatedWorkURL);
  return response;
};

export const getReportsheet = async () => {
  var response = get(timesheetUrl);
  return response;
};

export const searchReportsheet = async (keyword: string) => {
  var response = get(`${timesheetUrl}/search?name=${keyword}`);
  return response;
};

export const filterTimeSheet = async (data) => {
  var response = post(`${timesheetUrl}/filter`, data);
  return response;
};

export const getProjectDelivery = async () => {
  var response = get(projectDeliveryUrl);
  return response;
};

export const searchProjectDelivery = async (keyword: string) => {
  var response = get(`${projectDeliveryUrl}/search?name=${keyword}`);
  return response;
};

export const filterProjectDelivery = async (data) => {
  var response = post(`${projectDeliveryUrl}/filter`, data);
  return response;
};

export const filterProjectDeliveryInvoice = async (data) => {
  var response = post(`${projectDeliveryInvoiceUrl}/filter`, data);
  return response;
};

export const getActualHours = async () => {
  var response = get(actualHoursURL);
  return response;
};

export const searchActualHours = async (keyword: string) => {
  var response = post(`${actualHoursURL}/search`, {
    projectName: keyword
  });
  return response;
};

export const filterActualHours = async (data: any) => {
  var response = post(`${actualHoursURL}/quickresponse-filter`, data);
  return response;
};

export const getMonthlyHours = async () => {
  var response = get(monthlyHoursURL);
  return response;
};

export const searchMonthlyHours = async (keyword: string) => {
  var response = get(`${monthlyHoursURL}/search?name=${keyword}`);
  return response;
};

export const searchTimeSheet = async (empName: string) => {
  var response = get(`${timesheetBaseURL}/search?name=${empName}`);
  return response;
};

export const searchTimeSheetFilter = async (data) => {
  var response = post(`${timesheetBaseURL}/filter`, data);
  return response;
};
